{
  "alert": "Сигнал",
  "dismiss": "Отхвърляне"
}